import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { platform, PLATFORM } from '../../utils/getPlatform';
import styles from '../../assets/jss/components/ListCustomLayoutSeminarAndLivestream';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CustomTypography from '../../components/Typography/CustomTypography';
import ListCustomLayout from '../../components/ListCustomLayoutSeminarAndLivestream/ListCustomLayoutSeminarAndLivestream';
import dateUtils from '../../utils/dateUtils';

const useStyles = makeStyles(styles);

const ListSeminarViewerNonAuthCustomLayout = ({
    listData, customColor, locale,
}) => {
    const classes = useStyles({ customColor });
    const intl = useIntl();

    const createListView = () => {
        const viewTotal = [];
        Object.keys(listData).forEach((key) => {
            (Object.keys(listData[key]).forEach((roomData) => {
                let viewData = [];
                if (listData[key][roomData]) {
                    viewData = listData[key][roomData].map((seminar, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Fragment key={index}>
                            <ListCustomLayout
                                time={`${seminar.stime}~${seminar.etime}`}
                                date={dateUtils.formatJa(new Date(seminar.date), locale)}
                                title={seminar.title}
                                urlImg={seminar.speaker_img}
                                speakerName={seminar.speaker}
                                speakerProfile={locale === 'ja' ? seminar.speaker_profile : ''}
                                priceItem={seminar.cost > 0
                                    ? `${intl.formatNumber(seminar.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                                    : intl.formatMessage({ id: 'Free' })}
                                content={seminar.content}
                                customColor={customColor}
                                isViewDetail={false}
                            />
                        </Fragment>
                    ));
                }
                viewTotal.push(createTitle(roomData, viewData));
            }));
        });
        return viewTotal;
    };

    const createTitle = (title, viewData) => (
        <>
            <GridContainer>
                <GridItem>
                    <CustomTypography
                        className={classes.listTitle}
                        variant="h5"
                        bold
                        color="white"
                        customColor={customColor?.list_table?.title_text_color}
                    >
                        {title}
                    </CustomTypography>
                </GridItem>
            </GridContainer>
            <Divider className={classes.dividerUp} />
            {viewData}
        </>
    );

    return (
        <>
            {platform === PLATFORM.OTHER ? (
                <Container>
                    {createListView()}
                </Container>
            ) : createListView()}
        </>
    );
};

ListSeminarViewerNonAuthCustomLayout.defaultProps = {
    listData: [],
    customColor: {},
    locale: 'ja',
};

ListSeminarViewerNonAuthCustomLayout.propTypes = {
    listData: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default ListSeminarViewerNonAuthCustomLayout;
